import { render } from "./PartnerLocations.vue?vue&type=template&id=dec0a8b0"
import script from "./PartnerLocations.vue?vue&type=script&lang=js"
export * from "./PartnerLocations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__